import { GET_CLUB_PACKAGE_BY_CLUBID_REQUEST } from './constants';

export const getNextClubPackageByClubId = (clubId) => ({
  type: GET_CLUB_PACKAGE_BY_CLUBID_REQUEST,
  clubId
});
